function preventAnchorRedirection(sliderNode) {
	sliderNode.querySelectorAll('.flickity-button').forEach((button) => {
		button.addEventListener('click', (event) => {
			event.preventDefault();
		});
	});
}

function initCollectionMediaFlickity() {
	const mediaSliders = document.querySelectorAll('.js-collection-card-media-slider');
	mediaSliders.forEach((sliderNode) => {
		if (!sliderNode.flickity) {
			let slider = new Flickity(sliderNode, {
				prevNextButtons: true,
				pageDots: false,
				contain: true,
			});
			sliderNode.flickity = slider;
			preventAnchorRedirection(sliderNode);
		}
	});
}

function destroyCollectionMediaFlickity() {
	const mediaSliders = document.querySelectorAll('.js-collection-card-media-slider');
	mediaSliders.forEach((sliderNode) => {
		if (sliderNode.flickity) {
			sliderNode.flickity.destroy();
			sliderNode.flickity = null;
		}
	});
}

function initializeCollectionMediaSliders() {
	if (isMobile()) {
		initCollectionMediaFlickity();
	} else {
		destroyCollectionMediaFlickity();
	}
}

initializeCollectionMediaSliders();
window.addEventListener(
	'resize',
	debounce(() => {
		initializeCollectionMediaSliders();
	}, 100),
);
document.body.addEventListener('collection:update', initializeCollectionMediaSliders);
